

module.exports = __webpack_require__.stylable.create(
    "Popup906712685",
    {"classes":{"root":"Popup906712685__root","wrapper":"Popup906712685__wrapper","box":"Popup906712685__box","button":"Popup906712685__button"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    8,
    "Popup906712685",
    null
);
